import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-trending-up",
  "use": "icon-trending-up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-trending-up\" id=\"icon-trending-up\"><polyline points=\"23 6 13.5 15.5 8.5 10.5 1 18\" /><polyline points=\"17 6 23 6 23 12\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol